import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebaseConfig";
import CustomerMenu from "./CustomerMenu";
import AdminDashboard from "./AdminDashboard";
import LoginPage from "./LoginPage";
import CoffeeCostCalculator from "./CoffeeCostCalculator";
import CrepeCostCalculator from "./CrepeCostCalculator";
import SavoryCrepeCostCalculator from "./SavoryCrepeCostCalculator";
import AdminOrders from "./AdminOrders"; 
import logo from "./Logo.webp"
import "./App.css";
import OrderHistory from "./OrderHistory";
const CheckmateLounge = () => {
  const [admin, setAdmin] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [menu, setMenu] = useState([]);
  const auth = getAuth();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      setAdmin(user);
    });
  }, [auth]);

useEffect(() => {
  const fetchMenu = async () => {
    const menuCollection = await getDocs(collection(db, "inventory"));
    const fullMenu = menuCollection.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    console.log("📌 Full inventory fetched:", fullMenu);
    setMenu(fullMenu);
  };
  fetchMenu();
}, []);

  const handleLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      setAdmin(userCredential.user);
      alert("Logged in successfully!");
    } catch (error) {
      console.error("Error logging in: ", error);
      alert("Login failed. Please check your credentials.");
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setAdmin(null);
      alert("Logged out successfully!");
      window.location.href = "/"; // Redirect to menu after logout
    } catch (error) {
      console.error("Error logging out: ", error);
      alert("Failed to log out.");
    }
  };

  return (
    <Router>
      <div className="chess-Background">
        <div className="App-header">
          <h1 className="text-2xl font-bold text-gold">
            Checkmate Lounge
           {/* <img className="Logo" src={logo}></img> */}
           </h1>
          
         
        </div>
        <div>
            {admin ? (
              <>
                <Link to="/admin" className="mr-4 text-gold hover:underline">Admin Dashboard</Link>
                <button onClick={handleLogout} className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
                  Logout
                </button>
              </>
            ) : (
              <Link to="/login" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                {/* Admin Login */}
              </Link>
            )}
          </div>
        <Routes>
          <Route path="/" element={menu.length > 0 ? <CustomerMenu admin={admin} menu={menu.map(item => ({ id: item.id, name: item.name, customerPrice: (item.pricePerKg * 3.75).toFixed(2) }))} /> : <p>Loading Menu...</p>} />
          <Route path="/menu" element={menu.length > 0 ? <CustomerMenu admin={admin} menu={menu.map(item => ({ id: item.id, name: item.name, customerPrice: (item.pricePerKg * 3.75).toFixed(2) }))} /> : <p>Loading Menu...</p>} />
          <Route path="/orders" element={<AdminOrders />} />

	  <Route path="/admin" element={admin ? (
            <>
              <AdminDashboard />
              <div className='mt-10 p-6 bg-gray-900 rounded-lg'>
                <h2 className='text-2xl font-bold mb-4'>Admin Tools</h2>
		{admin && <SavoryCrepeCostCalculator menu={menu} setMenu={setMenu} />}
                {admin && <CoffeeCostCalculator menu={menu} setMenu={setMenu} />}
                {admin && <CrepeCostCalculator menu={menu} selectedExtras={[]} />}
              </div>
            </>
          ) : <Navigate to="/login" />} />
          <Route path="/login" element={<LoginPage admin={admin} setAdmin={setAdmin} />} />
	  <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/orders" element={<AdminOrders />} />
          <Route path="/order-history" element={<OrderHistory />} /> {/* Added Order History */}
        </Routes>
      </div>
    </Router>
  );
};

export default CheckmateLounge;

